import Footer from "../components/footer.js";
import Header from "../components/header.js";
import Testimonials from "../components/testimonials.js";
import Introduction from "../components/introduction.js";
import About from "../components/about.js";
import Work from "../components/work.js";
import Answers from "../components/answers.js";
import Nuggets from "../components/nuggets.js";
import Contact from "../components/contact.js";
import "../styles/OG_style.css";

function Home() {
  return (
    <>
      <Header />
      <main className="main" id="main">
        <Introduction />
        <About />
        <Nuggets />
        <Work />
        <Answers />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
export default Home;
